const debug = process.env.NODE_ENV !== "production";

const forceLoad = false;
const forceLoadDebug = false;

const config = {
  debug,
  appCustomUrlScheme: "freedom-lk",
  forceLoad: Boolean(forceLoad),
  forceLoadDebug: Boolean(forceLoadDebug),
  alwaysSavePagePositions: false,
  startTime: "04:00",
  api: {
    url: "https://lk-api.freedom-vrn.ru/lk/api/v1",
    jsonp: false,
    jsonpTimeout: 5,
    runtimeErrorErrorCode: 10,
    defaultErrorMessage: "Ошибка выполнения запроса",
  },
  site: {
    baseUrl: "https://freedom-vrn.ru",
    api: {
      url: "https://freedom-vrn.ru/api",
    },
  },
  billing: {
    tv: {
      packages: {
        freeId: 3,
        mainId: 18,
        familyId: 31,
        telemixId: 36,
      },
    },
  },
  history: {
    openedCount: 3,
  },
  messages: {
    openedCount: 3000,
  },
  alerts: {
    defaultOkTitle: "Подтверждение",
    defaultFailTitle: "Ошибка",
    okTimeout: 10,
    failTimeout: 20,
  },
  ui: {
    defaultMomentDateFormat: "L",
    defaultMomentDateTimeFormat: "L в HH:mm",
  },
  notification: {
    simpleSms: true, // true - отдельно не настравиаются push уведомления (sms - в широком понимании, все виды)
  },
  dialogs: {
    confirm: {
      defaultTitle: "Вопрос",
      defaultMessage: "Вы уверены?",
      defaultOkButtonText: "Да",
      defaultCancelButtonText: "Отмена",
    },
  },
  client: {
    defaultGetClientErrorMessage: "Ошибка получения информации о клиенте:!",
    defaultGetHistoryErrorMessage: "Ошибка при получении истории:!",
    betweenDatesGlobalError: 2 * 60, // в минутах
  },
  regexp: {
    email:
      /^$|^[a-za-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
  },
  password: {
    availableChars:
      "abcdefghijklmnopqrstuvwxyz" +
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
      "0123456789" +
      "!#$%&()*+,-./:;<=>?@[\\]^_`{|}~",
    minLength: 8,
    maxLength: 15,
  },
  seo: {
    /*yandexMetricId: '66515878',
    googleMetricId: 'UA-185343553-1'*/
  },
};

export default config;
